module.exports = __webpack_public_path__ + "static/media/01-start.70d4d4ad.png";